import { IOmniaShell } from "../shell"
import { HtmlTemplateString } from "../types"
import { reportFeedback } from "../usersnap"
import { getIconClass } from "../utils/utils"

const template: HtmlTemplateString = `
        <div class="modal-header omnia-modal-header">
            <h3 class="modal-title">
                <i ng-class="vm.getCssClass()"></i>
                <span>
                    <ng-transclude></ng-transclude>
                </span>
            </h3>
            <div ng-if="vm.help !== false" class="help" ng-include="'shared/main/help.html'"></div>
        </div>`

/** @internal */
export class DialogHeaderCtrl {


    static create(): ng.IDirective {

        return {
            controller: DialogHeaderCtrl,
            controllerAs: "vm",
            bindToController: true,
            scope: {
                icon: "<",
                help: "<"
            },
            transclude: true,
            template
        }

    }

    public icon: string
    public help: boolean

    static $inject = ["OmniaShell"]

    constructor(private shell: IOmniaShell) {
    }

    getCssClass() {
        return getIconClass(this.icon)
    }

    reportFeedback() {
        reportFeedback(this.shell.getSession())
    }
}
